import React from 'react';
import CloseModal from './CloseModal';
import { SaveIcon } from './IconButtons';
import InputField from './InputField';
 
const FollowUp = React.memo(({data, loading, onSubmit, onClose, onChange}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div className='relative w-[50vw] bg-white overflow-auto mx-10 mb-5 rounded-2xl '>
                <SaveIcon disabled={(data?.prevDate === data?.last_followup_date && data?.prevRemark?.trim() === data?.followup_remarks?.trim()) ||  loading} loading={loading} 
                className=" top-3 left-3" onClick={onSubmit} />
                <CloseModal onClick={onClose} />
                <div className=" p-3 ">
                    <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Position Followup</h1>
                    <div className=" grid grid-cols-2 items-center gap-3">
                        <InputField  id="company_name" name="company_name" type="text" label="Company Name:"
                        disabled
                        value={data?.company_name}
                        />
                        <InputField  id="postion" name="postion" type="text" label="Postion Name:"
                        disabled
                        value={data?.position}
                        />
                        <InputField  id="last_followup_date" name="last_followup_date" type="date" label="Last Followup Date:"
                        disabled={loading === '1'}
                        value={data?.last_followup_date}
                        onChange={onChange}
                        required
                        />
                        <InputField  id="upcoming_followup_date" name="upcoming_followup_date" type="date" label="Next Followup Date:"
                        disabled
                        value={data?.upcoming_followup_date}
                        />
                    </div>
                    <div>
                        <h2 className={`block text-left font-medium text-gray-700 mb-1`}>Remarks:</h2>
                        <textarea name="followup_remarks" id="followup_remarks" rows="5"
                        className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                        placeholder="Enter Remark..." onChange={onChange}
                        >{data?.followup_remarks}
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    );
})

export default FollowUp;
